import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceStatusFiltersHandler } from '../shared/services/device-status-filter-handler.service';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';
import { DetailViewService } from '../shared/services/detail-view.service';

@Component({
    selector: 'dl-device-detail-filters',
    templateUrl: './device-detail-filters.component.html',
    styleUrls: ['./device-detail-filters.component.scss']
})
export class DeviceDetailFiltersComponent implements OnInit {
    public static $name: string = 'deviceDetailFilters';

    deviceFilterFormControl = new FormControl();
    deviceFilterSubscription: Subscription;

    jobNumberFormControl = new FormControl();
    jobNumberSubscription: Subscription;

    @Input() filters: DeviceStatusFiltersHandler;
    @Input() hideFields: any;

    @Output() toggleReaderView = new EventEmitter();
    @Output() getDetail = new EventEmitter();

    constructor(private themeService: ThemeService,
        public detailViewService: DetailViewService) {
    }

    ngOnInit() {
        this.deviceFilterSubscription = this.deviceFilterFormControl.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe(newValue => {
                this.detailViewService.filter.wildcard = newValue;
            });

        this.jobNumberSubscription = this.jobNumberFormControl.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe(newValue => {
                this.detailViewService.query.jobNumber = newValue;
                this.onGetDetail();
            });
    }

    ngOnDestroy() {
        if (this.deviceFilterSubscription) { this.deviceFilterSubscription.unsubscribe(); }
        if (this.jobNumberSubscription) { this.jobNumberSubscription.unsubscribe(); }
    }

    categoryHandler($event) {
        this.filters.categories.selected = $event;

        this.detailViewService.filter.category = this.filters.categories.isSelected() ?
            this.filters.categories.selected.type : '';
    }

    clearFilters() {
        this.detailViewService.resetFilter();
        this.detailViewService.data = null;
    }

    onToggleReaderView() {
        this.toggleReaderView.emit(null);
    }

    onGetDetail() {
        this.getDetail.emit(null);
    }

    // Temporary override default behavior until we get rid of global styles.
    // Some global css was changing the text color to black in dark mode.
    isDarkTheme() {
        return this.themeService.getTheme() === 'casDark';
    }

}
